export const PermPlacementsListingGetters = {
  PermPlacementsFilters: 'PermPlacementsListingGetters.PermPlacementsFilters',
  PermPlacements: 'PermPlacementsListingGetters.PermPlacements',
  PermPlacementsFilteredRecordCount:
    'PermPlacementsListingGetters.PermPlacementsFilteredRecordCount',
  PermPlacementsListingOffset: 'PermPlacementsListingGetters.PermPlacementsListingOffset',
  PermPlacementsPerPage: 'PermPlacementsListingGetters.PermPlacementsPerPage',
  PermPlacementsSortBy: 'PermPlacementsListingGetters.PermPlacementsSortBy',
  PermPlacementsSortDirection: 'PermPlacementsListingGetters.PermPlacementsSortDirection',
  ModifiedPermPlacements: 'PermPlacementsListingGetters.ModifiedPermPlacements',
  PermPlacementsSortParams: 'PermPlacementsListingGetters.PermPlacementsSortParams',
  PermPlacementsPaginationParams: 'PermPlacementsListingGetters.PermPlacementsPaginationParams',
  PermPlacementIsLoading: 'PermPlacementsListingGetters.PermPlacementIsLoading',
  SelectedPermPlacements: 'SelectedPermPlacements'
};

export const PermPlacementsListingActions = {
  RetrievePermPlacements: 'PermPlacementsListingActions.RetrievePermPlacements',
  RetrievePermPlacementsFilteredRecordCount:
    'PermPlacementsListingActions.RetrievePermPlacementsFilteredRecordCount',
  SetPermPlacementsSortOrder: 'PermPlacementsListingActions.SetPermPlacementsSortOrder',
  SetPermPlacementsFilters: 'PermPlacementsListingActions.SetPermPlacementsFilters',
  SetPermPlacementsPaginationParameters:
    'PermPlacementsListingActions.SetPermPlacementsPaginationParameters',
  FilterListBySearchKey: 'PermPlacementsListingActions.FilterListBySearchKey',
  SelectPermPlacement: 'PermPlacementsListingActions.SelectPermPlacement',
  UpdatePermPlacements: 'PermPlacementsListingActions.UpdatePermPlacements'
};

export const PermPlacementsListingMutations = {
  SetPermPlacementsList: 'PermPlacementsListingMutations.SetPermPlacementsList',
  SetPermPlacementsFilteredRecordCount:
    'PermPlacementsListingMutations.SetPermPlacementsFilteredRecordCount',
  SetPermPlacementsSortOrder: 'PermPlacementsListingMutations.SetPermPlacementsSortOrder',
  SetPermPlacementsFilters: 'PermPlacementsListingMutations.SetPermPlacementsFilters',
  ResetPermPlacementsPaginationOffset:
    'PermPlacementsListingMutations.ResetPermPlacementsPaginationOffset',
  SetPermPlacementsPaginationParameters:
    'PermPlacementsListingMutations.SetPermPlacementsPaginationParameters',
  SetPermPlacementsLoading: 'PermPlacementsListingMutations.SetPermPlacementsLoading',
  SetSearchParam: 'PermPlacementsListingMutations.SetSearchParam',
  SelectPermPlacement: 'PermPlacementsListingActions.SelectPermPlacement'
};
